import type { MusicAccessDetailsModel } from "@libs/shared-ui";
import { MusicUnlockButton } from "./MusicUnlockButton";
import { useMusicUnlockPorts } from "./useMusicUnlockPorts";

/** Details' Unlock, on the app's sign-in, API and sheets
 *  (MusicUnlockButton). */
const Unlock = ({
  model,
  dataSharingConsent,
}: {
  model: MusicAccessDetailsModel;
  /** Recorded with the order, free or paid. */
  dataSharingConsent?: boolean;
}) => {
  const ports = useMusicUnlockPorts();
  return (
    <MusicUnlockButton
      model={model}
      dataSharingConsent={dataSharingConsent}
      ports={ports}
    />
  );
};

export default Unlock;
